<template>
  <div>
    <v-dialog v-model="value" persistent max-width="600px" scrollable>
      <v-card>
        <v-toolbar class="headline gradiente lighten-2 elevation-3">
          <v-toolbar-title>
            <v-flex xs12>
              <div class="white--text">
                {{ $t('reports.event_reports.event_reports_title') }}
              </div>
            </v-flex>
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-flex pt-3 px-4>
          <v-text-field
            v-model="filters.search"
            :label="$t('reports.event_reports.event_title')"
            append-icon="search"
            :disabled="working.wUpdate"
            :autofocus="!working.wUpdate"
            clearable
          >
            <template v-slot:prepend>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">help</v-icon>
                </template>
                {{ $t('reports.event_reports.search') }}
              </v-tooltip>
            </template>
          </v-text-field>
        </v-flex>
        <v-card-text>
          <v-list subheader three-line>
            <v-subheader>
              {{ $t('reports.event_reports.generate_event_reports') }}
            </v-subheader>
            <template v-for="(item, index) in filteredItems">
              <v-list-tile :key="index" avatar>
                <v-list-tile-avatar>
                  <v-icon color="grey">event_note</v-icon>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title class="grey--text text--darken-3">
                    <b>{{ item.title }}</b>
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    <b v-if="item.startDate">
                      {{ $t('reports.event_reports.start') }}
                    </b>
                    {{ formatDate(item.startDate) }}
                    <span v-if="item.endDate != null">
                      <b v-if="item.endDate">
                        {{ $t('reports.event_reports.end') }}
                      </b>
                      {{ formatDate(item.endDate) }}
                    </span>
                  </v-list-tile-sub-title>
                  <span>
                    {{
                      (item.confirmParent && !item.assistanceRequired
                        ? reportsDescriptions.onlyConfirmParent
                        : '') +
                      (!item.confirmParent && item.assistanceRequired
                        ? reportsDescriptions.onlyassistanceRequired
                        : '') +
                      (item.confirmParent && item.assistanceRequired
                        ? reportsDescriptions.both
                        : '')
                    }}
                  </span>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn icon @click="generateEventReport(item)">
                    <v-avatar :tile="tile" :size="avatarSize">
                      <v-icon color="grey">cloud_download</v-icon>
                    </v-avatar>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider
                :key="item.id"
                :inset="true"
                v-if="index != parents.length - 1"
              ></v-divider>
            </template>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="working.wUpdate" flat @click="close">
            {{ $t('generic.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <loading v-model="working.wUpdate" text="Trabajando..."></loading>
    <success v-model="toast.success" text="Creación Exitosa"></success>
    <error v-model="toast.failed" text="Ups ocurrió un error"></error>
    <confirm
      :value="confirm.value"
      :title="confirm.title"
      :description="confirm.description"
      v-on:desition="desitionLink"
    ></confirm>
    <ConfirmAccept
      :value="showPdfError"
      title="Aviso"
      description="Ups, al parecer todavía no hay registros de asistencia al evento."
      @toggle="onToggle"
    ></ConfirmAccept>
  </div>
</template>

<script>
import moment from 'moment'
import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import { noticeMixin } from '../../Mixins/NoticeReportsMixin'
import confirm from '../Dialogs/Confirm.vue'
import ConfirmAccept from '../Dialogs/ConfirmAccept.vue'
import error from '../Dialogs/Error.vue'
import loading from '../Dialogs/Loading.vue'
import success from '../Dialogs/Success.vue'
export default {
  props: ['value'],
  components: {
    loading,
    success,
    error,
    confirm,
    ConfirmAccept,
  },
  mixins: [noticeMixin],
  filters: {
    dateFormat(value) {
      return moment(String(new Date(value))).format('DD/MM/YYYY HH:mm')
    },
    dateFormat2(value) {
      return moment(String(new Date(value))).format('DD/MM/YYYY HH:mm')
    },
  },
  validations: {
    userForm: {
      firstName: { required },
      lastName: { required },
      gender: { required },
      personId: { required },
      level: {
        id: { required },
      },
      gg: {
        id: { required },
      },
    },
  },
  watch: {
    value() {
      this.selectedStds = []
      if (this.value) {
        this.getAllParents()
      }
    },
  },
  mounted() {},
  data: () => ({
    showPdfError: false,
    modals: {
      image: false,
    },
    reportsDescriptions: {
      onlyConfirmParent: 'Reporte de alumnos confirmados por tutores',
      onlyassistanceRequired: 'Reporte de asistencia de tutores al evento',
      both: 'Reporte de alumnos confirmados y asistencia de tutores al evento',
    },
    userForm: {
      level: {
        id: 0,
      },
      gg: {
        id: 0,
      },
    },

    avatarSize: '30px',
    tile: false,
    confirm: {
      value: false,
      title: '',
      description: '',
      show: false,
    },
    userImg: null,
    working: {
      wUpdate: false,
      wImage: false,
    },
    toast: {
      success: false,
      failed: false,
    },
    flags: {
      updateImage: false,
    },
    selectedStds: [],
    added: 0,
    parents: [],
    list: {
      header: 'Genera reportes de tus eventos',
    },
    filters: {
      search: '',
    },
    noticeToGenerate: [],
  }),
  methods: {
    formatDate(value) {
      return this.getLang === 'es'
        ? moment(String(new Date(value))).format('DD/MM/YYYY HH:mm')
        : moment(String(new Date(value))).format('MM/DD/YYYY HH:mm')
    },
    onToggle(e) {
      this.showPdfError = e
    },
    text: (item) => item.mail,
    setInfoToShowOnUpdate() {},
    getAllParents() {
      this.working.wUpdate = true
      this.$store
        .dispatch('notice/getEventReports')
        .then((response) => {
          this.parents = response.data.entity
          this.loading = false
          this.working.wUpdate = false
          this.selectedStds = []
          this.setInfoToShowOnUpdate()
        })
        .catch((error) => {
          console.log(error)
          this.working.wUpdate = false
          this.toast.failed = true
        })
    },

    submit() {
      this.added = 0
      if (this.selectedStds) {
        this.working.wUpdate = true
        for (var item in this.selectedStds) {
          this.sendAddToChildRequest(item)
        }
      }
    },
    async sendAddToChildRequest(item) {
      await this.$store
        .dispatch('tutor/addChildToParent', {
          pid: this.selectedStds[item].id,
          sid: this.student,
        })
        .then((response) => {
          this.$emit('linked', this.selectedStds[item])
          if (this.added == this.selectedStds.length - 1) {
            this.working.wUpdate = false
            this.toast.success = true
            this.close()
          }
          this.added++
        })
        .catch((error) => {
          if (this.added == this.selectedStds.length - 1) {
            this.working.wUpdate = false
            this.toast.failed = true
            this.close()
          }

          console.log(error)
          this.added++
        })
    },
    toggleAll(val) {
      if (val) {
        for (var i in this.filteredItems) {
          this.selectedStds.push(this.filteredItems[i])
        }
      } else {
        for (var i in this.filteredItems) {
          this.selectedStds.splice(
            1,
            this.selectedStds.indexOf(this.filteredItems[i])
          )
        }
      }
    },
    linkConfirm() {
      var stds = ''
      for (var item in this.selectedStds) {
        stds +=
          this.selectedStds[item].firstName +
          ' ' +
          this.selectedStds[item].lastName +
          ', '
      }
      this.confirm.description =
        (this.selectedStds.length > 1 ? 'Los tutores ' : 'El tutor ') +
        stds +
        (this.selectedStds.length > 1
          ? 'se ligarán al alumno '
          : 'se ligará al alumno ') +
        this.studentName +
        ' ¿Está seguro que desea realizar dicha acción?'
      this.confirm.value = true
      this.confirm.title = 'Confirmación'
      this.confirm.show = true
    },
    desitionLink(val) {
      this.confirm.value = false
      this.confirm.show = false
      if (val) {
        this.submit()
      }
    },
    close() {
      this.$emit('close', !this.value)
    },

    isHisParent(item) {
      for (var p in this.stdParents) {
        if (this.stdParents[p].id == item.id) {
          return true
        }
      }
      return false
    },
    generateEventReport(item) {
      this.$store
        .dispatch('notice/getInfoForReports', item.id)
        .then(async (response) => {
          this.noticeToGenerate = response.data.entity
          this.loading = false
          this.working.wUpdate = false
          this.selectedStds = []
          this.showPdfError = await this.downloadReportsNotice(
            this.getBranch,
            this.noticeToGenerate[0]
          )
        })
        .catch((error) => {
          console.log(error)
          this.working.wUpdate = false
          this.toast.failed = true
        })
    },
  },

  computed: {
    filteredItems() {
      if (!this.filters.search) return this.parents
      return this.parents.filter((item) => {
        return item.title
          .toLowerCase()
          .includes(this.filters.search.toLowerCase())
      })
    },
    ...mapGetters(['getBranch', 'getUser', 'getLang']),
  },
}
</script>

<style>
.no-properties {
  width: 0% !important;
  height: 0% !important;
}
</style>
